import { useEffect } from 'react'
import { get } from 'lodash'
import { useCookies } from 'react-cookie'
import { daysToSeconds } from 'utils/timeUtils'

export const CREDENTIALS_COOKIE_KEY = 'authCredentials'

const getCredentialsFromResponse = response => ({
  id: get(response, 'data.data.id'),
  subscribed: get(response, 'data.data.subscribed'),
  userType: get(response, 'data.data.userType'),
  freemiumVersion: get(response, 'data.data.freemiumVersion'),
})

const getCredentialsFromUser = ({
  id,
  subscribed,
  userType,
  freemiumVersion,
}) => ({
  id,
  subscribed,
  userType,
  freemiumVersion,
})

export const useCredentials = () => {
  const [cookies] = useCookies([CREDENTIALS_COOKIE_KEY])
  return cookies[CREDENTIALS_COOKIE_KEY]
}

const saveCookie = (setCookie, credentials) => {
  setCookie(CREDENTIALS_COOKIE_KEY, JSON.stringify(credentials), {
    secure: process.env.NODE_ENV === 'production',
    sameSite: 'Lax',
    maxAge: daysToSeconds(14),
    path: '/',
  })
}

const deleteCookie = removeCookie => {
  removeCookie(CREDENTIALS_COOKIE_KEY, { path: '/' })
}

export const useSaveCredentials = () => {
  const [, setCookie] = useCookies([CREDENTIALS_COOKIE_KEY])

  return response => {
    const credentials = getCredentialsFromResponse(response)
    saveCookie(setCookie, credentials)
  }
}

export const useDeleteCredentials = () => {
  const [, , removeCookie] = useCookies([CREDENTIALS_COOKIE_KEY])

  return () => {
    deleteCookie(removeCookie)
  }
}

export const useSyncCookiesWithUser = (user, userLoaded) => {
  const [allCookies, setCookie, removeCookie] = useCookies([
    CREDENTIALS_COOKIE_KEY,
  ])
  const cookie = allCookies[CREDENTIALS_COOKIE_KEY]

  useEffect(() => {
    if (!userLoaded) {
      return
    }

    if (user?.id && !cookie?.id) {
      saveCookie(setCookie, getCredentialsFromUser(user))
    } else if (!user && cookie?.id) {
      deleteCookie(removeCookie)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, userLoaded])
}
